<template>
	<div class="receipt-info-container">
		<info-item name="Subtotal" v-if="displaySubtotal" :value="displaySubtotal"/>
		<info-item name="Discount" v-if="displayTotalDiscount" :value="displayTotalDiscount"/>
		<info-item name="Service Charge" v-if="displayServiceCharge" :value="displayServiceCharge"/>
		<info-item name="Tip" v-if="displayTip" :value="displayTip"/>
		<info-item name="Tax" v-if="displayTax" :value="displayTax"/>
		<info-item name="Total" v-if="displayTotal" :value="displayTotal" :hideBorder="true"/>
	</div>
</template>

<script>
	import orderMixin from '@Mixin/orderMixin';
	import Formatter from '@/utils/Formatter';
	import routeMixin from '@Mixin/routeMixin';
	const InfoItemVue = (resolve) => {
		require.ensure([], () => {
			resolve(require('@OrderConfirmation/InfoItem.vue'));
		});
	};
	export default {
		mixins: [
			orderMixin,
			routeMixin,
		],
		props: {
			totals: {
				type: Object,
				default: () => {
					return {
						subtotal: 0,
						gratuity: 0,
						serviceCharge: 0,
						discount: 0,
						tax: 0,
						total: 0,
					};
				},
			},
		},
		components: {
			'info-item': InfoItemVue,
		},
		computed: {
			displayTotalDiscount() {
				return null;
			},
			displayServiceCharge() {
				const totals = this.totals;
				const serviceCharge = totals.serviceCharge;
				const formattedServiceCharge = Formatter.centsToDollars(serviceCharge);
				return formattedServiceCharge;
			},
			displayTip() {
				const totals = this.totals;
				if (!this._isOrderConfirmation) {
					return false;
				}
				const tip = totals.gratuity;
				const formattedTip = Formatter.centsToDollars(tip);
				return formattedTip;
			},
			displayTax() {
				const totals = this.totals;
				const tax = totals.tax;
				const formattedTax = Formatter.centsToDollars(tax);
				return formattedTax;
			},
			displaySubtotal() {
				const totals = this.totals;
				const subtotal = totals.subtotal || totals.subTotal; // TODO fix spelling inconsistency
				const formattedSubtotal = Formatter.centsToDollars(subtotal);
				return formattedSubtotal;
			},
			displayTotal() {
				const totals = this.totals;
				let total = totals.total;
				// TODO needs cleaner interface
				if (!total) {
					total = (totals.tax + totals.subTotal + totals.serviceCharge);
				}
				const formattedTotal = Formatter.centsToDollars(total);
				return formattedTotal;
			},
		},
		methods: {},
		mounted() {},
		created() {},
		destroyed() {},
	}
</script>

<style lang="scss" scoped>
	@import '@style-vars';
	@include mobile {}
	@include desktop {}
	@include tablet {}
</style>


// WEBPACK FOOTER //
// src/components/checkout/ReceiptInfo.vue